<template>
  <v-text-field
    v-model="searchParams.searchQuery"
    :label="$t('Search')"
    autocomplete="off"
    autofocus
    clearable
    outlined
    hide-details
    prepend-inner-icon="fal fa-search"
    single-line
    @input="onChangeDebounced"
  />
</template>

<script>
export default {
  name: 'SearchFilter',
  data () {
    return {
      searchParams: {
        searchQuery: ''
      }
    }
  },
  methods: {
    reset () {
      this.searchParams.searchQuery = ''
      this.onChange()
    },
    onChange () {
      this.$emit('change', this.searchParams)
    },
    onChangeDebounced: _.debounce(function () {
      this.onChange()
    }, 300)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vapevault/filters/SearchFilter.vue